<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="TIPO DE EVALUACIONES" key="1">
      <tipoevaluacion/>
    </a-tab-pane>
    <a-tab-pane  v-if="$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO') === 'NO'" tab="COMPETENCIA DE ROLES" key="2">
      <competenciaderoles/>
    </a-tab-pane>
    <a-tab-pane tab="TIPO DE EVALUADORES" key="3">
      <tipoevaluador/>
    </a-tab-pane>
    <a-tab-pane  v-if="$getConfigValue('NUEVO_METODO_EVALUACIONES', 'NO') === 'NO'" tab="CALIFICACIÓN Y CONVERSIONES" key="4">
      <conversion/>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  export default {
    name: 'Maestros'
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/TabsMaestros.vue